import { Navigate } from "react-router-dom";

import { FirebaseAuthContainer } from "../../common/containers/auth/firebase-auth-container.util";
import { LoaderView } from "../loader/loader.comp";

const HomeRedirect = () => {
    const { isAdmin } = FirebaseAuthContainer.useContainer();

    // Show loader while determining user role
    if (isAdmin === undefined) {
        return <LoaderView show={true} />;
    }

    // Redirect based on user role
    // Admin/Manager users see the dashboard
    // Regular users go to chat
    return isAdmin ? <Navigate to="/dashboard" /> : <Navigate to="/new-chat" />;
};

export default HomeRedirect;
